import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import Accordian from '../../../../utils/accordion';
// import "./style.scss";
// import 'react-phone-input-2/lib/style.css';
import RequestInfoModal from '../../../common/requestInfoModal';

function Admissions(props) {
	let data = props?.addmissionsData[0]?.admission_accord;
	let data_accordion = props?.addmissionsData[0]?.admission_accord?.admission_accordion;
	// console.log(props?.addmissionsData[0]?.admission_accord?.heading);

	let accordionData = [];
	accordionData = data_accordion?.map((key, index) => {
		return {
			heading: key.heading,
			content: key.content,
			open: false
		};
	});
	const [accordions, setAccordions] = useState(accordionData);

	const expandApplicationAccordion = ["/admissions", "/admissions/apply"];
	const shouldExpandApplicationAccordion = expandApplicationAccordion.includes(props.router.asPath);

	const expandInformation = ["/admissions/information"];
	const shouldExpandExpandInformation = expandInformation.includes(props.router.asPath);

	const expandTuitionFeesAccordion = ["/admissions/affordability", "/admissions/tuition-fees"];
	const shouldExpandTuitionFeesAccordion = expandTuitionFeesAccordion.includes(props.router.asPath);

	const expandFinancialAidAccordion = ["/admissions/financial-aid", "/admissions/scholarships"];
	const shouldExpandFinancialAidAccordion = expandFinancialAidAccordion.includes(props.router.asPath);

	const expandScholarshipGrant = ["/admissions/scholarship-grant"];
	const shouldExpandScholarshipGrant = expandScholarshipGrant.includes(props.router.asPath);
	// const [accordions, setAccordions] = useState([
	// 	{
	// 		heading: 'Application',
	// 		content: `
	// 						<p>Admission to Bayan Islamic Graduate School programs is currently granted through the Chicago Theological Seminary and prospective students can complete a preliminary application on this site.</p>
	// 						<h1>Bayan Degrees Offered:</h1>
	// 						<div class="admin-links">
	// 							<h6>MASTER OF DIVINITY (MDIV)</h6>
	// 							<div class="in-link">
	// 								<p><span>♦</span><a href="/islamic-chaplaincy">Islamic Chaplaincy</a>(75 units)</p>
	// 							</div>
	// 							<a target="_blank" href="https://www.ctschicago.edu/bayanchicago/" class="apply-btn">APPLY NOW</a>
	// 						</div>
	// 						<h6>MASTER OF ARTS (MA)</h6>
	// 						<div class="admin-links">
	// 							<div class="in-link">
	// 								<p><span>♦</span><a href="/islamic-studies">Islamic Studies</a>(48 units)</p>
	// 								<p><span>♦</span><a href="/islamic-leadership">Islamic Leadership</a>(48 units)</p>
	// 								<p><span>♦</span><a href="/islamic-education">Islamic Education</a>(48 units)</p>
	// 								<p><span>♦</span><a href="/islamic-theology">Islamic Theology</a>(48 units)</p>
	// 							</div>
	// 							<a target="_blank" href="https://www.ctschicago.edu/bayanchicago/" class="apply-btn">APPLY NOW</a>
	// 						</div>
	// 						<h1>NON-DISCRIMINATION POLICY</h1>
	// 						<p>Bayan admits students of any race, color, national and ethnic origin, or gender to all the rights, privileges, programs, and activities generally accorded or made available to students at the school. It does not discriminate on the basis of race, color, national and ethnic origin, or gender in administration of its educational policies, admissions policies, scholarship and loan programs, and athletic and other school-administered programs.</p>
	// 						`,
	// 		open: shouldExpandApplicationAccordion
	// 	},
	// 	{
	// 		heading: 'Information Sessions',
	// 		content: `<p>
	// 		The Bayan admissions team periodically schedules virtual information sessions. However, you can reach us at any time to learn more about Bayan’s academic programs, review admissions requirements, and discuss your educational and professional plans.
	// 		<br/>
	// 		Normally, during a period of up to two weeks in the middle of each semester, a number of Bayan courses have in-person meetings with faculty. These classes are held at the Chicago Theological Seminary campus. During these intensive periods, we encourage you to arrange a visit to meet staff and students. Currently, in-person classes are suspended due to Covid-19, and we hope to resume such gatherings in Summer 2021. <br/>
	// 		If you would like to speak with a graduate of Bayan, or a current student, please let us know. <br/>
	// 		You can reach us at admission@bayanonline.org or at (714) 862-2926.
	// 		</p>
	// 								<div class="text-center"><a id="request_info_btn" class="apply-btn">Request Info / Visit</a></div>
	//
	// 		`,
	// 		open: shouldExpandExpandInformation
	// 	},
	// 	{
	// 		heading: 'Tuition & Fees',
	// 		content: `<p>Bayan’s degree programs are accredited with the partnership of Chicago Theological Seminary, and Bayan’s students are matriculated at CTS. Thus, Bayan students are assessed the prevailing tuition rates at CTS for their courses. The current rate for a 3-unit course is $2846. <br/>
	// 		Interested applicants can explore federal financial aid with the CTS Financial Aid office. We encourage students to investigate external scholarships, and support from their local communities or employers. <br/>
	// 		Students interested in a Graduate Certificate are assessed the standard tuition rate. Certificate students are not eligible for scholarships or federal financial aid.
	// 		</p>`,
	// 		open: shouldExpandTuitionFeesAccordion
	// 	},
	// 	{
	// 		heading: 'Financial Aid & Scholarships',
	// 		content: `<p>All students are assessed full tuition for each course they are enrolled in by the school
	// 		 through which they are seeking a Bayan degree or certificate program, in accordance with the school's
	// 			present tuition rate. </p>
	// 			<h1>FINANCIAL AID</h1>
	// 			<p>Need-based grants may be available through the school's financial aid office, based on results of the Free Application for Federal Student Aid (FAFSA). Students must fill out the FAFSA in order to be evaluated and counseled on financial aid options. FAFSA can be filled out by clicking
	// 			 <Link href="https://www.ctschicago.edu/bayanchicago/" as="https://www.ctschicago.edu/bayanchicago/"><a target="_blank" href="https://www.ctschicago.edu/bayanchicago/">here.</a></Link></p>
	// 			<h1>SCHOLARSHIPS</h1>
	// 			<p>Currently, Bayan provides scholarship support through named scholarships to students who meet the eligibility criteria. Outside of the named scholarships, no scholarships or discounts are available at present.</p>
	// 				<div class="gray-admin-block">
	// 					<h1>Muhammad Ali Scholarship for Spiritual Leadership </h1>
	// 					<div>
	// 						<h3>Eligible incoming full-time students may be awarded this $24,000/year scholarship.</h3>
	// 						<p>The Bayan Muhammad Ali Scholarship for Spiritual Leadership is an honor bestowed upon deserving
	// 						and highly qualified full-time entering graduate students enrolled in Bayan’s degree programs.
	// 						Prospective awardees are individuals admitted to the school for graduate study and who currently
	// 							work in an under-served community. </p>
	// 							<div class="text-center"><a href="/scholarship" as="/scholarship" class="apply-btn">Apply Now</a></div></p>
	//
	// 					</div>
	// 					<span></span>
	// 				</div>
	// 				<div class="gray-admin-block">
	// 					<h1>Omar and Azmeralda Alfi Scholarship for Educational Leadership  </h1>
	// 					<div>
	// 						<h3>Eligible full-time students may be awarded this $24,000/year scholarship</h3>
	// 						<p>The Bayan Omar and Azmeralda Alfi Scholarship for Educational Leadership is an honor bestowed
	// 						upon exceptional, highly qualified full-time entering or continuing graduate students enrolled in
	// 						 Bayan’s M.A. in Islamic Education degree program.  </p>
	// 						 <div class="text-center"><Link href="https://www.ctschicago.edu/bayanchicago/" as="https://www.ctschicago.edu/bayanchicago/"><a target="_blank" href="https://www.ctschicago.edu/bayanchicago/" class="apply-btn">Apply Now</a></Link></div></p>
	// 					</div>
	// 					<span></span>
	// 				</div>
	// 				<div class="gray-admin-block">
	// 					<h1>Hassan Hathout Spiritual Care Scholarship  </h1>
	// 					<div>
	// 						<h3>For one incoming full-time student per year admitted into the M.Div. in Islamic Chaplaincy degree program. </h3>
	// 						<p>Bayan, in partnership with the Hassan Hathout Legacy Foundation, awards a full tuition
	// 						merit-based scholarship for exceptional incoming full-time graduate students admitted to Bayan’s
	// 						 Master of Divinity in Islamic Chaplaincy program. The scholarship is named after the late Dr.
	// 						 Hassan Hathout, who was a physician, ethicist, and Islamic leader who contributed to the Muslim
	// 						 American community for decades. His emphasis on human dignity, ethics, peacemaking, harmony, and
	// 							love are characteristics Bayan seeks to inculcate in its student body, especially among those
	// 							dedicating their lives to chaplaincy.</p>
	// 							<div class="text-center"><Link href="https://www.ctschicago.edu/bayanchicago/" as="https://www.ctschicago.edu/bayanchicago/"><a target="_blank" href="https://www.ctschicago.edu/bayanchicago/" class="apply-btn">Apply Now</a></Link></div></p>
	// 					</div>
	// 					<span></span>
	// 				</div>
	// 			`,
	// 		open: shouldExpandFinancialAidAccordion
	// 	},
	// 	{
	// 		heading: 'Certificate in Islamic Chaplaincy',
	// 		content: `
	// 		<h1> PURPOSE</h1>
	// 		<ul>
	// 			<li> Expand access to Bayan degree programs</li>
	// 			<li> Help address root concern many students have - cost</li>
	// 			<li> Provide a strategic incentive for students to enroll</li>
	// 			<li> Leverage Bayan’s database</li>
	// 			<li> Increase enrollment in Spring 2021 and beyond!</li>
	// 		</ul>
	// 		<h1>INITIATIVE</h1>
	// 		<p>
	// 			PLEXUSS proposes an initiative that will provide up to
	// 			$ 250,000 in student grants to new Bayan degreeseeking students. These grants will be funded 100% by
	// 			PLEXUSS based on certain criteria and conditions.
	// 			Bayan will fully administer and award this grant funding
	// 			provided by PLEXUSS.
	// 		</p>
	// 		<h1>GRANTS VS. SCHOLARSHIPS</h1>
	// 		<ul>
	// 			<li>Grants: Every student that meets specific criteria is eligible
	// 			for a financial grant that does not need to be repaid.</li>
	// 			<li> Scholarships: Financial scholarships that do not need to be
	// 			repaid that are awarded to select students that meet certain
	// 			baseline criteria and go through a consistently-applied selection
	// 			process.</li>
	// 		</ul>
	// 		<h1>GRANT AMOUNTS</h1>
	// 		<ul style={{listStyle:'none'}} >
	// 			<li><p>Amount: &nbsp;&nbsp;  $ 200 Per Credit Hour + $ 50 Application Fee</p></li>
	// 			<li><p>Limit: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  $ 5,050 or 24 Months (Whichever Occurs First)</p></li>
	// 			<li><p>Use:   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  Bayan Tuition & Application Fee</p></li>
	// 		</ul>
	// 		<h1>GRANT REQUIREMENTS</h1>
	// 		<ul>
	// 			<li> Available to new students who want to pursue a graduate degree at Bayan.</li>
	// 			<li> Must demonstrate leadership potential and have such a purpose.</li>
	// 			<li> Must have maintained an average undergraduate GPA of 3.0+*.</li>
	// 			<li> Must maintain an average GPA of 3.5+ at Bayan to remain eligible.</li>
	// 		</ul>
	// 		<p>* Exceptions made for extenuating circumstances or divinity students without undergraduate degree</p>
	// 		<h1>GRANT STRUCTURE</h1>
	// 		<ul>
	// 			<li> Up to $ 2,500 is available for a student’s first semester, then $ 1,000 per semester.</li>
	// 			<li> Must be renewed each semester. Is not guaranteed after the first semester.</li>
	// 			<li> Requires student to successfully complete each class.</li>
	// 			<li> Grant is paid following student’s successful completion of classes each semester.  </li>
	// 		</ul>
	// 	`,
	// 		open: shouldExpandScholarshipGrant
	// 	}
	// ]);

	const [openRequestInfoModal, setOpenRequestInfoModal] = useState(false);

	const { userId } = useSelector((state) => ({
		userId: state.userAuth.userId,
	}), shallowEqual);

	useEffect(() => {
		if (userId != null) {
			let widget = document.getElementById('request_info_btn');
			if (widget) {
				widget.remove();
			}
		}
	}, []);

	const handleRequestInfo = () => {
		setOpenRequestInfoModal(true);
	}

	const closeModals = () => {
		  setOpenRequestInfoModal(false);
	}
	return (
		<>
			<div className="admissions-page">
				{openRequestInfoModal &&
					<RequestInfoModal
						closeModals={closeModals}
					/>
				}
				<div className="container">
					{/*<h1 className="text-center headingF headingF-sm">ADMISSIONS</h1>*/}
					<h1 className="text-center headingF headingF-sm">{data?.heading ?? ''}</h1>
					{/* <div className="background-image">
						<img src="https://d310ox1f4zno4b.cloudfront.net/static-content/admissions-bg.png.webp" alt="admission background image" />
						</div> */}
					<Accordian showRequestInfo={handleRequestInfo} accordions={accordions} setAccordions={setAccordions} />
				</div>
			</div>


		</>
	);
}

export default Admissions;
